import { useTranslation } from 'react-i18next'
import { useDialogController } from '@machobear/design-system'
import { Wrapper } from '@/features/Application/elements'
import { SectionTitle } from '@/features/Application/elements'
import RentToIncome from './rentToIncome'
import InfoDialog from './info-dialog'

const RentToIncomeView = ({ data, application, isLocked, isLoading, standalone = false }) => {
  const { t } = useTranslation()
  const title = t('l.application.view.rent_to_income_ratio.link', 'Rent-to-Income Ratio')

  const {
    visible: isInfoDialogVisible,
    showModal: showInfoDialog,
    closeModal: closeInfoDialog
  } = useDialogController(false)

  return (
    <>
      <Wrapper id="income-to-rent-ratio">
        <SectionTitle
          title={title}
          handleInfoClick={showInfoDialog}
          clickId="application-trust-score-info-rent-income"
          showInfo
          score={data?.score}
          maxScore={data?.max_score}
          rate={data?.rate}
          isLocked={isLocked}
          isLoading={isLoading}
        />

        <RentToIncome
          data={data}
          application={application}
          isLocked={isLocked}
          isLoading={isLoading}
          standalone={standalone}
        />
      </Wrapper>
      <InfoDialog visible={isInfoDialogVisible} closeModal={closeInfoDialog} />
    </>
  )
}

export default RentToIncomeView
